import { LinkButton } from "lib/miolo";
import punycode from "punycode";
import { useState } from "react";
import Linkify from "react-linkify";
import * as palette from "../palette";
import getSafeCommentContent from "./getSafeCommentContent";

interface ICommentContentProps {
  bodyAsPlainText: string;
  truncatedCommentLength?: number;
}

export default function CommentContent({ truncatedCommentLength = 600, bodyAsPlainText }: ICommentContentProps) {
  const fullCommentContent = getSafeCommentContent(bodyAsPlainText);
  const truncatedCommentContent = fullCommentContent.slice(0, truncatedCommentLength);

  const [displayingContent, setDisplayingContent] = useState<string>(truncatedCommentContent);

  const hasTruncation = truncatedCommentContent.length !== fullCommentContent.length;
  const isDisplayingTruncatedContent = displayingContent.length !== fullCommentContent.length;

  return (
    <div className="flex flex-col space-y-3">
      <div
        className="font-aeonik text-sm font-normal leading-6 tracking-wider text-gray-600 dark:text-gray-400"
        css={{
          whiteSpace: "pre-line",
          wordWrap: "break-word",
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
      >
        <Linkify
          // eslint-disable-next-line react/no-unstable-nested-components
          componentDecorator={(href, text, key) => {
            const linkText = punycode.toUnicode(text).replace(/^https?:\/\//i, "");
            return (
              <a
                href={punycode.toUnicode(href)}
                key={key}
                target="_blank"
                rel="noopener noreferrer"
                css={{
                  color: palette.link,
                  textDecoration: "none",
                  wordBreak: "break-word",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                  "&:visited": {
                    color: palette.linkVisited,
                  },
                }}
              >
                {linkText.length > 25 ? `${linkText.slice(0, 25)}...` : linkText}
              </a>
            );
          }}
        >
          {isDisplayingTruncatedContent ? `${displayingContent}...` : displayingContent}
        </Linkify>
      </div>

      {isDisplayingTruncatedContent && (
        <div>
          <LinkButton onClick={() => setDisplayingContent(fullCommentContent)}>Ver mais</LinkButton>
        </div>
      )}

      {hasTruncation && !isDisplayingTruncatedContent && (
        <div>
          <LinkButton onClick={() => setDisplayingContent(truncatedCommentContent)}>Ver menos</LinkButton>
        </div>
      )}
    </div>
  );
}
